<template>
	<div :class="`toast toast--${severity}`" v-html="messageHTML"></div>
</template>

<script>
const formatters = [{ char: '\\*', tag: 'strong' }, { char: '_', tag: 'em' }]

export default {
	name: 'toast',
	props: {
		message: String,
		severity: {
			type: String,
			default: 'info'
		}
	},
	computed: {
		messageHTML() {
			// Convert message formatting to HTML
			let html = this.message
			for (const { char, tag } of formatters) {
				const re = new RegExp(char + '([^ ].*?[^ ])' + char, 'g')
				const sub = `<${tag}>$1</${tag}>`
				html = html.replace(re, sub)
			}
			return html
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.toast {
	padding: 1rem;
	margin: 1.5rem;
	width: calc(100vw - 3rem);
	background-color: $white;
	box-shadow: 0 0.25rem 0.5rem rgba($black, 0.25);

	&--info {
		border-left: 0.25rem solid $green-50;
	}
	&--warning {
		border-left: 0.25rem solid $orange-95;
	}
	&--error {
		border-left: 0.25rem solid $red-85;
	}

	@include mq(md) {
		margin: 1rem;
		width: 20rem;
	}
}
</style>
